import querystring from 'querystring';

/**
 * Get the current wuery params from the url and decoded it into a object
 * @return {object} object with the params decoded
 * @example
 * // when the url is  something like
 * // http://xxxxx/xxxxx?ws=meeting-rooms&southwest=36.422476,-123.084249&lang=en-us
 * // it returns {ws: "meeting-rooms", southwest: "36.422476,-123.084249", lang: "en-us"}
 */

export const getDecodedQueryParams = () => {
  const windowLocation = window.location.search;
  const queryParams = decodeURI(windowLocation.slice(1));
  const params = querystring.decode(queryParams);
  return params;
};

export const encodedQueryParams = queryParams =>
  `?${querystring.encode(queryParams)}`;
